module.exports = __webpack_public_path__ + "img/logo_color.1272cb3c.png";